import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';

@Feature()
export class BrushFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public onClick() {
        this.getFormatBrushManager()?.onClickButton();
        this.twdReport();
    }

    public onDoubleClick() {
        this.getFormatBrushManager()?.onDoubleClickButton();
        this.twdReport();
    }


    public isChecked() {
        // 存在动画刷时，不启用选中状态
        return !this.getAnimBrushManager()?.animBrushState
            && !!this.getFormatBrushManager()?.formatBrushState.data;
    }

    public getFormatBrushManager() {
        return this.getAppService().editableServiceLayer?.formatBrushManager;
    }

    private getAnimBrushManager() {
        return this.getAppService().editableServiceLayer?.animBrushManager;
    }
}
